import axios from 'axios'
import axiosCancel from 'axios-cancel'

import config from './config.js'

axiosCancel(axios, {
  debug: false // default
})

// axios.defaults.headers = {
//   'Access-Control-Allow-Origin': '*',
//   'Content-Type': 'application/json'
// }

axios.defaults.baseURL = config.baseUrl + config.prefix

export default axios



// WEBPACK FOOTER //
// ./src/scripts/axios.js